module.exports = __webpack_public_path__ + "static/media/dc.8249827f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/homepage/dc.svg
// module id = 869
// module chunks = 21